import React from 'react'

function Home ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width="25.179" height="24" viewBox="0 0 25.179 24">
      <g transform="translate(0 -0.367)">
        <path d="M66.191,169.965H45.867V154.1H47v14.734H65.062V154.1h1.129Zm0,0" transform="translate(-43.44 -145.598)" />
        <path d="M24.487,10.995l-11.9-9.2-11.9,9.2L0,10.106,12.589.367l12.589,9.738Zm0,0" />
      </g>
    </svg>
  )
}

Home.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Home
